import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { common } from 'src/app/app.common';
import { SaveData } from 'src/app/models/output.model/ResponseLogin';
import { ExportService } from 'src/app/utils/services/export.service';
import { AllService } from 'src/app/Utils/services/all.service';
import { TraCuuCongViecGiangDayService } from 'src/app/utils/services/tra-cuu-cong-viec-giang-day.service';
import { ClassService } from 'src/app/utils/services/class.service';
@Component({
  selector: 'app-tra-cuu-cong-viec-giang-day',
  templateUrl: './tra-cuu-cong-viec-giang-day.component.html',
  styleUrls: ['./tra-cuu-cong-viec-giang-day.component.scss'],
})
export class TraCuuCongViecGiangDayComponent implements OnInit {
  public com: common;
  Token: any;
  dataTable: any = [];
  dataHe: any = [];
  dataKhoa: any = [];
  dataKhoaHoc: any = [];
  dataKhoaHoc2: any = [];
  Nam_hoc_arr: any = [];
  recordTotal: any = 0;
  dataLop: any = [];
  dataLop2: any = [];
  dataNCV: any = [];
  dataCV: any = [];
  dataCV2: any = [];
  dataMonHoc: any = [];
  dataBoMon: any = [];
  dataLoaiLop: any = [];
  listClass: any = [];
  maGV: any;
  filter = new FormGroup({
    Hoc_ky: new FormControl(0),
    Nam_hoc: new FormControl(
      new Date().getFullYear() - 1 + '-' + new Date().getFullYear()
    ),
    ID_he: new FormControl(0),
    ID_khoa: new FormControl(0),
    ID_lop: new FormControl(0),
    iD_bm: new FormControl(0),
    Khoa_hoc: new FormControl(0),
    dien_giai_mon_hoc: new FormControl(''),
    iD_nhom_cong_viec: new FormControl(0),
    iD_cong_viec: new FormControl(0),
    iD_loai_lop: new FormControl(0),
    ten_mon: new FormControl(''),
    ten_lop: new FormControl(''),
    giang_vien: new FormControl(''),
    Don_vi_tinh: new FormControl(''),
    So_tiet_chuan: new FormControl(0),
    So_sinh_vien: new FormControl(0),
    Thu: new FormControl(''),
  });
  public SaveDate: SaveData;
  constructor(
    public exportService: ExportService,
    private modalService: NgbModal,
    private AllService: AllService,
    public router: Router,
    private toastr: ToastrService,
    private spinner: NgxSpinnerService,
    private TraCuuCongViecGiangDayService: TraCuuCongViecGiangDayService,
    private ClassService: ClassService
  ) {}

  ngOnInit(): void {
    let element, name, arr;
    element = document.getElementById('menu1');
    arr = element.className.split(' ');
    name = 'menu-open';
    if (arr.indexOf(name) == -1) {
      element.className += ' ' + name;
    }
    var yearNow = new Date().getFullYear() + 4;
    for (var i = 0; i < 10; i++) {
      let Nam_hoc_string = yearNow + '-' + (yearNow + 1);
      let object = {
        value: Nam_hoc_string,
        name: Nam_hoc_string,
      };
      this.Nam_hoc_arr.push(object);
      yearNow--;
    }
    this.com = new common(this.router);
    this.com.CheckLogin();
    var a = this.com.getUserinfo();
    this.Token = a.Token;
    var b = this.com.getSaveData();
    this.filter.patchValue({
      giang_vien: b?.Ma_gv,
    });
    this.getList();
    this.getClass();
    this.submit();
  }

  getClass = async () => {
    return await this.ClassService.Danh_sach_lop_dang_hoc().subscribe(
      (res: any) => {
        this.listClass = res;
      }
    );
  }

  getList() {
    this.spinner.show();
    let IDhe;
    let IDKhoahoc;
    this.AllService.getHe(this.Token).subscribe((z) => {
      this.dataHe = z;
      this.AllService.getKhoa(this.Token).subscribe((z) => {
        this.dataKhoa = z;
        this.AllService.getKhoaHoc(this.Token).subscribe((z) => {
          this.dataKhoaHoc = z.Data;
          this.dataKhoaHoc2 = this.dataKhoaHoc;
          this.dataKhoaHoc2 = this.dataKhoaHoc2.filter(
            (item, i, arr) =>
              arr.findIndex((t) => t.Khoa_hoc === item.Khoa_hoc) === i
          );
        });
      });
    });

    let iDNCV;
    this.AllService.getNhomCongViec(this.Token).subscribe((z) => {
      this.dataNCV = z.Data;
      iDNCV = z.Data[0].ID_nhom_cong_viec;
      this.AllService.getCongViec(this.Token).subscribe((z) => {
        this.dataCV = z.Data;
        this.dataCV2 = this.dataCV;
      });
    });

    this.AllService.getLoaiLop(this.Token).subscribe((z) => {
      this.dataLoaiLop = z.Data;
    });

    this.AllService.getBoMon(this.Token).subscribe((z) => {
      this.dataBoMon = z;
    });

    this.spinner.hide();
  }

  changeHe() {
    if (this.filter.value.ID_he != 0) {
      this.dataKhoaHoc2 = this.dataKhoaHoc.filter(
        (i) => i.ID_he == this.filter.value.ID_he
      );
      if (this.filter.value.ID_khoa != 0) {
        this.dataKhoaHoc2 = this.dataKhoaHoc2.filter(
          (i) => i.ID_khoa == this.filter.value.ID_khoa
        );
      }
      this.dataKhoaHoc2 = this.dataKhoaHoc2.filter(
        (item, i, arr) =>
          arr.findIndex((t) => t.Khoa_hoc === item.Khoa_hoc) === i
      );
    } else {
      this.dataKhoaHoc2 = this.dataKhoaHoc;
      if (this.filter.value.ID_khoa != 0) {
        this.dataKhoaHoc2 = this.dataKhoaHoc2.filter(
          (i) => i.ID_khoa == this.filter.value.ID_khoa
        );
      }
      this.dataKhoaHoc2 = this.dataKhoaHoc2.filter(
        (item, i, arr) =>
          arr.findIndex((t) => t.Khoa_hoc === item.Khoa_hoc) === i
      );
    }
  }
  changeKhoa() {
    if (this.filter.value.ID_he != 0) {
      if (this.filter.value.ID_khoa != 0) {
        this.dataKhoaHoc2 = this.dataKhoaHoc.filter(
          (i) => i.ID_he == this.filter.value.ID_he
        );
        this.dataKhoaHoc2 = this.dataKhoaHoc2.filter(
          (i) => i.ID_khoa == this.filter.value.ID_khoa
        );
      } else {
        this.dataKhoaHoc2 = this.dataKhoaHoc.filter(
          (i) => i.ID_he == this.filter.value.ID_he
        );
      }
      this.dataKhoaHoc2 = this.dataKhoaHoc2.filter(
        (item, i, arr) =>
          arr.findIndex((t) => t.Khoa_hoc === item.Khoa_hoc) === i
      );
    } else {
      if (this.filter.value.ID_khoa != 0) {
        this.dataKhoaHoc2 = this.dataKhoaHoc;
        this.dataKhoaHoc2 = this.dataKhoaHoc2.filter(
          (i) => i.ID_khoa == this.filter.value.ID_khoa
        );
      } else {
        this.dataKhoaHoc2 = this.dataKhoaHoc;
      }
      this.dataKhoaHoc2 = this.dataKhoaHoc2.filter(
        (item, i, arr) =>
          arr.findIndex((t) => t.Khoa_hoc === item.Khoa_hoc) === i
      );
    }
  }

  changeNhomCongViec() {
    if (this.filter.value.iD_nhom_cong_viec != '') {
      this.dataCV2 = this.dataCV.filter(
        (i) => i.ID_nhom_cong_viec == this.filter.value.iD_nhom_cong_viec
      );
      this.dataCV2 = this.dataCV2.filter(
        (item, i, arr) =>
          arr.findIndex((t) => t.ID_cong_viec === item.ID_cong_viec) === i
      );
    } else this.dataCV2 = this.dataCV;
  }

  submit() {
    this.spinner.show();
    this.dataTable = [];
    let req = {
      Nam_hoc: this.filter.value.Nam_hoc,
      Hoc_ky: this.filter.value.Hoc_ky,
      ID_he: this.filter.value.ID_he,
      ID_khoa: this.filter.value.ID_khoa,
      Khoa_hoc: this.filter.value.Khoa_hoc,
      ID_bm: this.filter.value.iD_bm,
      ID_nhom_cong_viec: this.filter.value.iD_nhom_cong_viec,
      ID_cong_viec: this.filter.value.iD_cong_viec,
      ID_loai_lop: this.filter.value.iD_loai_lop,
      Giang_vien: this.filter.value.giang_vien,
      Ten_mon: this.filter.value.ten_mon,
      Ten_lop: this.filter.value.ten_lop,
    };
    this.TraCuuCongViecGiangDayService.getList(req, this.Token).subscribe(
      (z) => {
        this.dataTable = z.ListData;
      }
    );
    this.spinner.hide();
  }

  Excel() {
    if (this.filter.value.giang_vien == '') {
      this.toastr.warning('Vui lòng nhập mã giảng viên để thống kê!');
      return false;
    }
    this.com = new common(this.router);
    this.com.CheckLogin();
    var a = this.com.getUserinfo();
    let req = {
      Nam_hoc: this.filter.value.Nam_hoc,
      Hoc_ky: this.filter.value.Hoc_ky,
      ID_he: this.filter.value.ID_he,
      ID_khoa: this.filter.value.ID_khoa,
      Khoa_hoc: this.filter.value.Khoa_hoc,
      ID_bm: this.filter.value.iD_bm,
      ID_nhom_cong_viec: this.filter.value.iD_nhom_cong_viec,
      ID_cong_viec: this.filter.value.iD_cong_viec,
      ID_loai_lop: this.filter.value.iD_loai_lop,
      Giang_vien: this.filter.value.giang_vien,
      Ten_mon: this.filter.value.ten_mon,
      Ten_lop: this.filter.value.ten_lop,
    };

    var r = confirm('File của bạn sẽ được tải xuống trong giây lát!');
    if (r) {
      this.spinner.show();
      this.TraCuuCongViecGiangDayService.Excel(req, a.Token).subscribe((z) => {
        if (z.Status == 1) {
          this.exportService.exportExcelByte(
            z.FileData,
            'TraCuuCongViec'
          );
          this.toastr.success('File đã được tải xuống', 'Tác vụ thành công');
          this.spinner.hide();
        } else {
          this.toastr.error(z.Message, 'Tác vụ thất bại');
          this.spinner.hide();
        }
      });
    }
  }
}
